import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { showError } from '../../../../core/alert/sweetAlertConfig';

interface BuildingDTO {
  id: number;
  name: string;
  noOfFloors: number;
  locationName: string;
  locationId: number;
  description?: string | null;
}

interface ViewBuildingModuleProps {
  show: boolean;
  onHide: () => void;
  building: BuildingDTO | null;
}

const ViewBuildingModule: React.FC<ViewBuildingModuleProps> = ({
  show,
  onHide,
  building,
}) => {
  if (!building) {
    showError('No building data available. Please try again.');
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>View Building: {building.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="buildingId">
            <Form.Label>ID</Form.Label>
            <Form.Control
              type="text"
              value={building.id}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="buildingName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={building.name}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="noOfFloors">
            <Form.Label>No. of Floors</Form.Label>
            <Form.Control
              type="number"
              value={building.noOfFloors}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="locationName">
            <Form.Label>Location</Form.Label>
            <Form.Control
              type="text"
              value={building.locationName}
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={building.description || 'No description available'}
              disabled
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={onHide}
              className="me-2"
            >
              Close
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ViewBuildingModule;